export function findLastIndex<T>(array: T[], predicate: (value: T, index: number, obj: T[]) => boolean): number {
  let l = array.length;
  while (l > 0) {
    l -= 1;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (predicate(array[l], l, array)) {
      return l;
    }
  }

  return -1;
}

function isDefinedNumber(a: number | null | undefined) {
  return a !== null && a !== undefined && !isNaN(a);
}

export function minBy<T>(list: T[], accessor?: (item: T) => number): number {
  const values = list.map(accessor ?? Number).filter(isDefinedNumber);

  return Math.min(...values);
}

export function maxBy<T>(list: T[], accessor?: (item: T) => number): number {
  const values = list.map(accessor ?? Number).filter(isDefinedNumber);

  return Math.max(...values);
}

export function sumBy<T>(list: T[], accessor?: (item: T) => number): number {
  return list.map(accessor ?? Number).reduce((acc, curr) => {
    if (!isDefinedNumber(curr)) {
      return acc;
    }

    return acc + curr;
  }, 0);
}

export function groupBy<T>(list: T[], group: (item: T) => number | string): Record<string, T[]> {
  return list.reduce<Record<string, T[]>>((groups, item) => {
    const key = group(item);

    const currGroup = groups[key];
    if (currGroup === undefined) {
      groups[key] = [item];
    } else {
      groups[key] = [...currGroup, item];
    }

    return groups;
  }, {});
}

export function unique<T>(list: T[]): T[] {
  return [...new Set(list)];
}

export function range(start: number, stop: number, step = 1) {
  return Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
}
